/* ARVAFEX — comportamiento del tema */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- panel lateral ---------- */
    var drawer = document.getElementById('drawer');
    var drbg = document.getElementById('drbg');
    var burger = document.getElementById('burger');
    var drx = document.getElementById('drx');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('open');
      if (drbg) drbg.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      if (drbg) drbg.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drx) drx.addEventListener('click', closeDrawer);
    if (drbg) drbg.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ---------- buscador móvil (cabecera) ---------- */
    var searchToggle = document.getElementById('searchToggle');
    var msearch = document.getElementById('msearch');
    if (searchToggle && msearch) {
      searchToggle.addEventListener('click', function () {
        var isOpen = msearch.classList.toggle('open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var input = document.getElementById('MobileHeaderSearch');
          if (input) input.focus();
        }
      });
    }

    /* ---------- galería de producto ---------- */
    var main = document.getElementById('pdpMain');
    var thumbs = document.querySelectorAll('.thumb');
    if (main && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          if (!src) return;
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = src;
            main.style.opacity = 1;
          }, 150);
          thumbs.forEach(function (x) { x.classList.remove('on'); });
          t.classList.add('on');
        });
      });
    }

    /* ---------- acordeones ---------- */
    document.querySelectorAll('.acc-h').forEach(function (h) {
      h.addEventListener('click', function () {
        h.parentElement.classList.toggle('open');
      });
    });

    /* ---------- pestañas ---------- */
    var tabBtns = document.querySelectorAll('.tabs button');
    if (tabBtns.length) {
      tabBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          tabBtns.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          document.querySelectorAll('.tabp').forEach(function (p) {
            p.classList.toggle('on', p.getAttribute('data-panel') === b.getAttribute('data-tab'));
          });
        });
      });
    }

    /* ---------- selector de cantidad ---------- */
    document.querySelectorAll('.qty').forEach(function (q) {
      var input = q.querySelector('input');
      var minus = q.querySelector('[data-qty="minus"]');
      var plus = q.querySelector('[data-qty="plus"]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) { input.value = v - 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ---------- carrito: cambiar cantidad recarga la línea ---------- */
    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });

  });
})();


(function(){
  'use strict';
  document.addEventListener('DOMContentLoaded', function(){
    var cdbg = document.getElementById('cdbg');
    var cartdr = document.getElementById('cartdr');
    var cdClose = document.getElementById('cdClose');
    var cdItems = document.getElementById('cdItems');
    var cdEmpty = document.getElementById('cdEmpty');
    var cdFoot = document.getElementById('cdFoot');
    var cdSubtotal = document.getElementById('cdSubtotal');
    var cartIconLink = document.getElementById('cart-icon-link');
    var cartBadge = document.getElementById('cart-badge');

    function money(cents){
      return (cents/100).toFixed(2).replace('.', ',') + '€';
    }

    function openCartDrawer(){
      if(!cartdr) return;
      document.body.classList.add('no-scroll');
      cdbg.classList.add('open');
      cartdr.classList.add('open');
    }
    function closeCartDrawer(){
      if(!cartdr) return;
      document.body.classList.remove('no-scroll');
      cdbg.classList.remove('open');
      cartdr.classList.remove('open');
    }

    function renderCartDrawer(cart){
      if(!cdItems) return;
      if(cartBadge){
        if(cart.item_count > 0){
          cartBadge.style.display = 'flex';
          cartBadge.textContent = cart.item_count;
        } else {
          cartBadge.style.display = 'none';
        }
      }
      if(cart.item_count === 0){
        if(cdEmpty) cdEmpty.style.display = 'block';
        cdItems.style.display = 'none';
        if(cdFoot) cdFoot.style.display = 'none';
        cdItems.innerHTML = '';
        return;
      }
      if(cdEmpty) cdEmpty.style.display = 'none';
      cdItems.style.display = 'block';
      if(cdFoot) cdFoot.style.display = 'block';
      if(cdSubtotal) cdSubtotal.textContent = money(cart.total_price);
      var html = '';
      cart.items.forEach(function(item, idx){
        html += '<div class="cd-item" data-line="' + (idx+1) + '">' +
          '<img src="' + item.image + '" alt="">' +
          '<div class="cd-item-info">' +
            '<div class="cd-item-title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cd-item-variant">' + item.variant_title + '</div>' : '') +
            '<div class="cd-item-qty">' +
              '<button type="button" class="cd-qty-btn" data-action="dec">-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" class="cd-qty-btn" data-action="inc">+</button>' +
              '<button type="button" class="cd-remove" data-action="remove">Eliminar</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-item-price">' + money(item.final_line_price) + '</div>' +
        '</div>';
      });
      cdItems.innerHTML = html;
    }

    function cdFetchCart(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCartDrawer);
    }

    function cdChangeLine(line, quantity){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({line: line, quantity: quantity})
      }).then(function(r){ return r.json(); }).then(renderCartDrawer);
    }

    if(cdItems){
      cdItems.addEventListener('click', function(e){
        var btn = e.target.closest('[data-action]');
        if(!btn) return;
        var itemEl = btn.closest('.cd-item');
        var line = parseInt(itemEl.getAttribute('data-line'), 10);
        var qtySpan = itemEl.querySelector('.cd-item-qty span');
        var qty = parseInt(qtySpan.textContent, 10);
        if(btn.getAttribute('data-action') === 'inc'){ cdChangeLine(line, qty+1); }
        else if(btn.getAttribute('data-action') === 'dec'){ cdChangeLine(line, Math.max(0, qty-1)); }
        else if(btn.getAttribute('data-action') === 'remove'){ cdChangeLine(line, 0); }
      });
    }

    if(cdbg){ cdbg.addEventListener('click', closeCartDrawer); }
    if(cdClose){ cdClose.addEventListener('click', closeCartDrawer); }

    if(cartIconLink){
      cartIconLink.addEventListener('click', function(e){
        e.preventDefault();
        cdFetchCart();
        openCartDrawer();
      });
    }

    var productForm = document.getElementById('ProductForm');
    if(productForm){
      productForm.addEventListener('submit', function(e){
        e.preventDefault();
        var fd = new FormData(productForm);
        var submitBtn = productForm.querySelector('[type="submit"]');
        if(submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Accept':'application/json'},
          body: fd
        }).then(function(r){ return r.json(); }).then(function(){
          return fetch('/cart.js').then(function(r){ return r.json(); });
        }).then(function(cart){
          renderCartDrawer(cart);
          openCartDrawer();
          if(submitBtn) submitBtn.disabled = false;
        }).catch(function(){
          if(submitBtn) submitBtn.disabled = false;
          productForm.submit();
        });
      });
    }

    cdFetchCart();
  });
})();
